module.exports = __webpack_public_path__ + "static/media/how_pt.4857a34c.vtt";